<template>
  <v-col cols="12" lg="6">
    <v-card class="mt-12" height="100%">
      <div class="text-center">
        <img
          v-if="imageHandle != null"
          class="profile_image elevation-6"
          :src="`/img/management/${imageHandle}.jpg`"
          :srcset="`/img/management/${imageHandle}.jpg,
                    /img/management/${imageHandle}@2x.jpg 2x`"
          :alt="`${name} - ${position} - HealthView Capital`"
        >
      </div>
      <h3 :class="['mt-3 text-h5 text-center primary--text font-weight-bold', imageHandle ? '' : 'pt-5']">
        {{ name }}
      </h3>
      <h4 class="text-center subheading secondary--text font-weight-bold">
        {{ position }}
      </h4>
      <v-card-text>
        <slot />
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: 'ManagementProfileCard',
  props: {
    name: {
      type: String,
      default: '',
    },
    imageHandle: {
      type: String,
      default: null,
    },
    position: {
      type: String,
      default: null,
    },
  },
}
</script>

<style scoped>
img.profile_image {
  margin-top: -75px;
  border-top-left-radius: 150px !important;
  border-top-right-radius: 150px !important;
  border-bottom-left-radius: 150px !important;
  border-bottom-right-radius: 150px !important;
  max-width: 300px;
}
</style>
